import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ErrorPageComponent } from './shared/pages/error-page.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  // Not lazy: when the app's code files can't be loaded (an outage), the error page must not need one either.
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'company',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/company/company.routes').then((m) => m.COMPANY_ROUTES),
  },
  // Backward-compat redirects
  {
    path: 'manager',
    redirectTo: 'company',
    pathMatch: 'prefix',
  },
  {
    path: 'compliance',
    redirectTo: 'company',
    pathMatch: 'prefix',
  },
  {
    path: '**',
    redirectTo: 'error',
  },
];
